import { defineMessages } from "react-intl";

export const messages = defineMessages({
    fastshiftAssistanceModalDescription: {
        id: "fastshift.assistance.section.modal.description",
        defaultMessage:
            "Post a comment to a chosen ticket to receive FastShift team help.",
        description: "Description for the FastShift assistance modal"
    },
    fastshiftAssistanceModalTitle: {
        id: "fastshift.assistance.section.modal.title",
        defaultMessage: "Request FastShift assistance",
        description: "Title for the FastShift assistance modal"
    },
    fastshiftAssistanceModalSubtitleNote: {
        id: "fastshift.assistance.section.modal.subtitle-note",
        defaultMessage: "Required fields are marked with an asterisk",
        description:
            "Subtitle note for the FastShift assistance modal, describing that form fields with an asterisk are required"
    },
    fastshiftAssistanceModalDropdownLabel: {
        id: "fastshift.assistance.section.modal.dropdown-label",
        defaultMessage: "Select a MOVE ticket",
        description:
            "Label for the FastShift assistance modal dropdown where users can select a MOVE ticket"
    },
    fastshiftAssistanceModalDropdownHint: {
        id: "fastshift.assistance.section.modal.dropdown-hint",
        defaultMessage: "Type to search for a name or key",
        description:
            "User hint for ticket selection dropdown in fastshift assistance modal"
    },
    fastshiftAssistanceModalCommentLabel: {
        id: "fastshift.assistance.section.modal.comment-label",
        defaultMessage: "Add a comment to the ticket",
        description: "Label for comment field in fastshift assistance modal"
    },
    fastshiftAssistanceModalSendButton: {
        id: "fastshift.assistance.section.modal.send-button",
        defaultMessage: "Send",
        description:
            "Button text for sending the comment to the selected move ticket, on the fastshift assistance modal"
    },
    fastshiftAssistanceModalCancelButton: {
        id: "fastshift.assistance.section.modal.cancel-button",
        defaultMessage: "Cancel",
        description: "Button text for closing the fastshift assistance modal"
    },
    fastshiftAssistanceModalFailedRequestMessage: {
        id: "fastshift.assistance.section.modal.failed-request-error-message",
        defaultMessage: "An error occurred. Please try again later",
        description:
            "Message shown if there is a server error when trying to create a comment after hitting send"
    },
    fastshiftAssistanceModalFieldIsRequiredMessage: {
        id: "fastshift.assistance.section.modal.form-field-required",
        defaultMessage: "This field is required",
        description: "Error message when user doesn't fill in a required field"
    },
    fastshiftAssistanceModalSuccessFlagTitle: {
        id: "fastshift.assistance.section.modal.success-flag-title",
        defaultMessage: "Comment created",
        description:
            "Title for flag shown when a comment is successfully created on a migration support ticket"
    },
    fastshiftAssistanceModalSuccessFlagDescription: {
        id: "fastshift.assistance.section.modal.success-flag-description",
        defaultMessage: "Comment has been successfully created.",
        description:
            "Description for flag shown when a comment is successfully created on a migration support ticket"
    },
    fastshiftAssistanceModalSuccessFlagAction: {
        id: "fastshift.assistance.section.modal.success-flag-action",
        defaultMessage: "View ticket",
        description:
            "Text for a link that will redirect customer to view their migration support ticket (to which they just posted a comment)"
    },
    fastshiftAssistanceModalErrorFlagTitle: {
        id: "fastshift.assistance.section.modal.error-flag-title",
        defaultMessage: "An error occurred",
        description:
            "Title for flag shown when there is an error creating a comment on a migration support ticket"
    },
    fastshiftAssistanceModalErrorFlagDescription: {
        id: "fastshift.assistance.section.modal.success-flag-description",
        defaultMessage: "Please try again later.",
        description:
            "Description for flag shown when there is an error creating a comment on a migration support ticket"
    },
    fastshiftAssistanceModalEmptyDescription: {
        id: "fastshift.assistance.section.modal.empty.description",
        defaultMessage:
            "You don’t have any open migration support tickets in the system. To request assistance, please create a new migration support ticket.",
        description:
            "Description for the FastShift assistance modal when the customer has no open support tickets"
    },
    fastshiftAssistanceModalEmptyModalRaiseTicketButton: {
        id: "fastshift.assistance.section.modal.empty.raise-ticket-button",
        defaultMessage: "Go to Support",
        description:
            "Button to redirect to another website to raise a new support request"
    }
});
